import React from "react"
import { Outlet, useParams } from "react-router-dom"
import { Loader } from "src/components/global/Loader"
import { ModuleErrors } from "src/components/ui/ModuleErrors"
import { useActions, useAppState } from "src/state"

export function SuperAdminVenueLayout() {

    const { venueId } = useParams()

    const { loading, currentItem, errors } = useAppState().tenants
    const { subscribeToItem, unsubscribeFromItem } = useActions().tenants

    React.useEffect(() => {
        subscribeToItem({ id: venueId });
        return () => {
            unsubscribeFromItem()
        }
    }, [venueId, subscribeToItem, unsubscribeFromItem])

    if (loading) return <Loader />
    if (!currentItem) return <Loader />

    return (
        <React.Fragment>
            <ModuleErrors errors={errors} />
            <Outlet/>
        </React.Fragment>
    )

}